import React from 'react';
import './MapContainer.css';
import Map from './Map';
import Searchbar from 'components/Searchbar/Searchbar';
import MunicipalityTable from 'components/Table/MunicipalityTable';
import { MunicipalityNameData, MunicipalityNameValues, NameIndices, NameType, Person, PersonFileInfo, Sex } from 'lib/Types';
import translationsJson from 'data/translations.json';

const translations: Translations = translationsJson;

interface Props {
    nameIndices: NameIndices;
    nameType: NameType;
    selectedPerson?: Person;
    onClick(municipalityId: string): void;
}

class MapContainer extends React.Component<Props, { data: MunicipalityNameValues | null }> {
    private personInfo: PersonFileInfo | undefined;
    private jsonData: MunicipalityNameData | undefined;

    constructor(props: Props) {
        super(props);

        this.state = {
            data: null
        };

        this.personInfo = undefined;
        this.jsonData = undefined;

        this.onSearch = this.onSearch.bind(this);
    }

    private onSearch(personInfo: PersonFileInfo) {
        if (this.personInfo?.fileId === personInfo.fileId) {
            if(this.personInfo.person.name === personInfo.person.name) {
                return;
            }

            if(this.jsonData !== undefined) {
                this.personInfo = personInfo;
                this.setState({data: this.jsonData[personInfo.person.name] as MunicipalityNameValues});
                return;
            }
        }

        let folder;
        if (this.props.nameType === NameType.Firstname) {
            folder = "firstnames";
        } else {
            folder = "lastnames";
        }
        fetch(`data/${folder}/${personInfo.fileId}.json`).then(response => response.json()).then(jsonFile => {
            this.personInfo = personInfo;
            this.jsonData = jsonFile;
            if ('merged' in jsonFile) {
                this.setState({ data: jsonFile[personInfo.person.name] });
            } else {
                this.setState({ data: jsonFile });
            }
        });
    }

    private isNewData(oldPerson: Person | undefined, newPerson: Person | undefined) : boolean {
        if(oldPerson === undefined && newPerson === undefined)
            return false;
        if(newPerson === undefined)
            return false;
        if(oldPerson === undefined)
            return true;
        if(oldPerson === newPerson)
            return false;
        if(oldPerson.name === newPerson.name && oldPerson.sex === newPerson.sex)
            return false;
        return true;
    }

    componentDidMount(): void {
        if(this.props.selectedPerson) {
            const name = this.props.selectedPerson!.name;
            let fileId = -1;
            const nameIndex = this.props.nameIndices[name];
            if (typeof nameIndex === "number") {
                fileId = nameIndex;
            } else {
                fileId = this.props.selectedPerson!.sex === Sex.Male ? nameIndex.m! : nameIndex.f!;
            }
    
            this.onSearch({ fileId: fileId, person: this.props.selectedPerson! });
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.isNewData(prevProps.selectedPerson, this.props.selectedPerson)) {
            console.log("Mapcontainer update");
            const name = this.props.selectedPerson!.name;
            let fileId = -1;
            const nameIndex = this.props.nameIndices[name];
            if (typeof nameIndex === "number") {
                fileId = nameIndex;
            } else {
                fileId = this.props.selectedPerson!.sex === Sex.Male ? nameIndex.m! : nameIndex.f!;
            }

            this.onSearch({ fileId: fileId, person: this.props.selectedPerson! });
        }
    }

    render() {
        const catType = (this.props.nameType === NameType.Lastname || !this.personInfo) ? "o" : this.personInfo.person.sex;
        const name = this.personInfo === undefined ? "" : this.personInfo.person.name;
        let title = "";
        if (this.props.nameType === NameType.Lastname) {
            title = translations.tableTitleLastname[window.lang] + " " + this.personInfo?.person.name;
        } else {
            title = translations.tableTitleFirstname[window.lang] + " " + this.personInfo?.person.name;
        }
        return (
            <div className="map-container">
                <Searchbar placeholder={this.props.nameType === NameType.Firstname ? translations.firstname[window.lang] : translations.lastname[window.lang]} inputData={this.props.nameIndices} onSearch={this.onSearch} presetValues={this.props.selectedPerson ? [this.props.selectedPerson] : undefined} />
                <Map type={this.props.nameType} person={this.personInfo?.person} data={this.state.data ? this.state.data : {}} onClick={this.props.onClick}/>
                <MunicipalityTable data={this.state.data ? this.state.data : {} } category={catType} title={title} name={name}/>
            </div>
        );
    }
}

export default MapContainer;